import type { ZodError } from 'zod'

/**
 * Mensajes de Zod indexados por el `name` del campo.
 *
 * Se indexa dos veces: por la primera parte de la ruta (`items`) y por la ruta
 * completa (`items.0.price`). Con sólo la primera, todos los errores de una
 * lista se apilaban bajo el mismo nombre y ganaba el primero, así que un campo
 * anidado nunca podía pedir su propio mensaje.
 */
export const collectIssues = (error: ZodError): Record<string, string> => {
  const issues: Record<string, string> = {}

  for (const issue of error.issues) {
    const path = (issue.path ?? []).map(String)
    const root = path[0] ?? ''
    const full = path.join('.')

    if (root && !issues[root]) issues[root] = issue.message
    if (full && full !== root && !issues[full]) issues[full] = issue.message
  }

  return issues
}

/**
 * Errores que toca **enseñar**, que no son todos los que hay: los de Zod sólo se
 * ven cuando el campo ya se tocó, o en cuanto se ha intentado enviar una vez.
 * Así un formulario recién abierto no aparece en rojo. Los puestos a mano (los
 * que devuelve la API) se ven siempre y ganan al de Zod.
 *
 * La regla estaba escrita tres veces —el memo de `useForm` y las dos funciones
 * del contexto de `<Form>`—, que es como se acaba con tres comportamientos.
 */
export const visibleErrors = (issues: Record<string, string>, touched: readonly string[], submitted: boolean, manual: Record<string, string> = {}): Record<string, string> => {
  const visible: Record<string, string> = {}

  if (submitted) {
    Object.assign(visible, issues)
  } else {
    for (const name of touched) {
      if (issues[name]) visible[name] = issues[name]
    }
  }

  return { ...visible, ...manual }
}
